// extracted by mini-css-extract-plugin
export default {"missingGeolocation":"DeliverySettingsTab_missingGeolocation__Vfzww"};